import React from 'react';
import ct from './capacityTracker.module.css';
import { AgGridReact } from '@ag-grid-community/react';
import DatePicker from 'react-multi-date-picker';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { MultiSelect } from 'primereact/multiselect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCapacity } from '../../../Hooks/Features/CapacityTracker/useCapacity';
import panelHeaderTemplate from '../../../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate.jsx';
import { SkeletonDataTable } from '../../../components/Loader/Loader.jsx';

function CapacityTracker() {

  const { leadDropdown, projectLeadSelected, setProjectLeadSelected, projectDropdown, projectSelected, setProjectSelected, hoveredRange, setHoveredRange, upsertHoveredRange, setUpsertHoveredRange, isEdit, userDropdown, userSelected, setUserSelected, enteredWorkingHours, setEnteredWorkingHours, coldef, rowData, handleEdit, UpsertCapacityTracker, loader, callApi, setCallApi, isChanged, setIsChanged } = useCapacity()

  const handleComponent = (event) => {
    if (isChanged || event === "close") {
      setCallApi(!callApi);
      setIsChanged(false);
    }
  }

  return (
    <div>

      <div className='row mt-1'>
        <div className='col-lg-2 col-md-2 col-12'>
          <MultiSelect
            placeholder='Project Lead'
            options={leadDropdown}
            optionLabel='user_display_name'
            value={projectLeadSelected}
            onChange={(e) => { setProjectLeadSelected(e.target.value); setIsChanged(true) }}
            onHide={() => handleComponent()}
            filter filterInputAutoFocus
            panelHeaderTemplate={(options) => panelHeaderTemplate(options, 'project_lead', projectLeadSelected, setProjectLeadSelected, () => handleComponent("close"))} />
        </div>
        <div className='col-lg-2 col-md-2 col-12'>
          <MultiSelect
            placeholder='Project'
            options={projectDropdown}
            optionLabel='project_name'
            value={projectSelected}
            onChange={(e) => { setProjectSelected(e.value); setIsChanged(true); }}
            onHide={() => handleComponent()}
            filter filterInputAutoFocus
            panelHeaderTemplate={(options) => panelHeaderTemplate(options, 'project', projectSelected, setProjectSelected, () => handleComponent("close"))} />
        </div>
        <div className='col-lg-2 col-md-2 col-12'>
          <DatePicker
            value={hoveredRange}
            onChange={setHoveredRange}
            range
            rangeHover
          />
        </div>
        <div className='col-lg-5 col-md-5 col-12 text-right'>
          {isEdit && (
            <div className={ct['ct-edit-dropdowns']}>
              <div>
                <DatePicker
                  value={upsertHoveredRange}
                  onChange={setUpsertHoveredRange}
                  range
                  rangeHover
                />
              </div>
              <div className={ct['ct-edit-users']}>
                <MultiSelect
                  placeholder='Users'
                  options={userDropdown}
                  optionLabel='user_display_name'
                  value={userSelected}
                  onChange={(e) => setUserSelected(e.target.value)}
                  filter filterInputAutoFocus
                  panelHeaderTemplate={(options) => panelHeaderTemplate(options, 'users', userSelected, setUserSelected)}
                />
              </div>
              <div>
                <input placeholder='Working hours' type='Number' value={enteredWorkingHours} onChange={(e) => setEnteredWorkingHours(e.target.value)} min={0} style={{ width: "130px" }} />
              </div>
              <button onClick={() => UpsertCapacityTracker("", "", true)}>Apply</button>
            </div>
          )}
        </div>
        <div className='col-lg-1 col-md-1 col-12 text-right'>
          <button onClick={() => handleEdit()} className='btn btn-primary'>
            {isEdit ? <FontAwesomeIcon icon="fa-solid fa-circle-xmark" /> : <FontAwesomeIcon icon="fa-solid fa-edit" />}
          </button>
        </div>
      </div>
      <div className='row mt-2'>
        <div className='col-lg-12 col-md-12 col-12'>
          {loader ? <SkeletonDataTable numSkeletons={20} /> :
            <div className={`${ct['ct-table']} ct-table-class ag-theme-alpine custom-grid`}>
              <AgGridReact rowData={rowData} columnDefs={coldef} rowHeight={30} headerHeight={30} />
            </div>
          }
        </div>
      </div>
    </div>
  )
}

export default CapacityTracker